/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['půl.', 'pol.', 'r.', 'd.', 'o.', 'v.', 'n.'],
    ['půln.', 'pol.', 'r.', 'dop.', 'odp.', 'več.', 'v n.'],
    ['půlnoc', 'poledne', 'ráno', 'dopoledne', 'odpoledne', 'večer', 'v noci']
  ],
  [
    ['půl.', 'pol.', 'ráno', 'dop.', 'odp.', 'več.', 'noc'],
    ['půlnoc', 'poledne', 'ráno', 'dopoledne', 'odpoledne', 'večer', 'noc'],
  ],
  [
    '00:00', '12:00', ['04:00', '09:00'], ['09:00', '12:00'], ['12:00', '18:00'],
    ['18:00', '22:00'], ['22:00', '04:00']
  ]
];
